"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeWordLimitsFromFields = exports.removeIndexPrefixFromUrl = exports.prepareSearchableFields = exports.prepareFilterFields = exports.mergeArraysWithoutWordLimits = exports.getWordLimitForKey = exports.getSearchableFromArr = exports.getFieldsWithoutDecorators = exports.extractLang = exports.cutTextWithWordsLimit = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _stripHtml = require("./strip-html");

const removeWordLimitsFromFields = arr => arr.map(item => item.split(',')).flat().map(item => item.split(':')[0]);

exports.removeWordLimitsFromFields = removeWordLimitsFromFields;

const getWordLimitForKey = (key, arr) => {
  const item = arr === null || arr === void 0 ? void 0 : arr.find(field => {
    const [attr] = field.split(':');
    return key === attr;
  });
  if (!item) return undefined;
  const [, value] = item.split(':');
  return value ? Number(value) : undefined;
};

exports.getWordLimitForKey = getWordLimitForKey;

const getSearchableFromArr = arr => arr === null || arr === void 0 ? void 0 : arr.filter(item => item.startsWith('searchable')).map(item => {
  const reParam = /\((\w*)\)/;
  const param = item.match(reParam);

  if (param) {
    return param[1];
  }

  return null;
}).filter(item => item !== null);

exports.getSearchableFromArr = getSearchableFromArr;

const mergeArraysWithoutWordLimits = arrays => [...new Set(...[arrays.filter(Boolean).map(arr => removeWordLimitsFromFields(arr)).flat()])];

exports.mergeArraysWithoutWordLimits = mergeArraysWithoutWordLimits;

const cutTextWithWordsLimit = (value, numberOfWords) => {
  if (typeof value !== 'string') {
    return '';
  }

  if (typeof numberOfWords !== 'number') {
    return value;
  }

  return value.trim().split(/\s+/).slice(0, numberOfWords).join(' ');
};

exports.cutTextWithWordsLimit = cutTextWithWordsLimit;

const prepareSearchableFields = (settings, data) => {
  const fields = mergeArraysWithoutWordLimits([settings === null || settings === void 0 ? void 0 : settings.attributesToSnippet, settings === null || settings === void 0 ? void 0 : settings.searchableAttributes, getSearchableFromArr(settings === null || settings === void 0 ? void 0 : settings.attributesForFaceting)]);
  return fields.reduce((acc, key) => {
    if (removeWordLimitsFromFields((settings === null || settings === void 0 ? void 0 : settings.attributesToSnippet) || []).includes(key)) {
      acc[key] = {
        value: cutTextWithWordsLimit((0, _stripHtml.stripHtml)(data[key]), getWordLimitForKey(key, settings === null || settings === void 0 ? void 0 : settings.attributesToSnippet))
      };
    } else {
      acc[key] = data[key];
    }

    return acc;
  }, {});
};

exports.prepareSearchableFields = prepareSearchableFields;

const extractLang = value => value && value.lang ? value.lang.split('-')[0] : 'en';

exports.extractLang = extractLang;

const removeIndexPrefixFromUrl = obj => {
  if (typeof obj === 'object' && obj !== null && typeof obj.url === 'string') {
    var _obj$url;

    const url = (_obj$url = obj.url) === null || _obj$url === void 0 ? void 0 : _obj$url.replace(/^.*###/, '');
    return { ...obj,
      url
    };
  }

  return obj;
};

exports.removeIndexPrefixFromUrl = removeIndexPrefixFromUrl;

const getFieldsWithoutDecorators = fields => Array.isArray(fields) ? fields.map(item => {
  const fieldNameRe = /\((.*)\)/;
  const fieldName = item.match(fieldNameRe);
  return fieldName ? fieldName[1] : item;
}).filter(Boolean) : fields;

exports.getFieldsWithoutDecorators = getFieldsWithoutDecorators;

const prepareFilterFields = (settings, data) => {
  const fieldKeys = getFieldsWithoutDecorators(settings.attributesForFaceting);
  return (fieldKeys === null || fieldKeys === void 0 ? void 0 : fieldKeys.reduce((acc, field) => {
    let itemData = (0, _get2.default)(data, field);

    if (!itemData) {
      const parentField = field.split('.')[0];
      const childField = field.split('.').pop();

      if (childField) {
        itemData = (0, _get2.default)(data, parentField);

        if (Array.isArray(itemData)) {
          itemData = itemData.filter(Boolean).map(item => item[childField]);
        }
      }
    }

    if (itemData) {
      const onlyObjects = Array.isArray(itemData) ? itemData.filter(Boolean).filter(item => Object.keys(item).length !== 0) : [String(itemData)];

      if (onlyObjects.some(item => item.id)) {
        acc[`${field}.id`] = onlyObjects.filter(item => item.id).map(item => String(item.id));
      } else {
        acc[field] = Array.isArray(itemData) ? itemData.filter(Boolean).map(item => String(item)) : [String(itemData)];
      }
    }

    return acc;
  }, {})) || {};
};

exports.prepareFilterFields = prepareFilterFields;